import { mapState } from "vuex";

var Brands = {
  created: function() {
    this.fetchAllBrands();
  },
  methods: {
    fetchAllBrands(params = '') {
      this.$store.dispatch("product/FetchAllBrands", params);
    },
  },
  computed: {
    ...mapState("product", ["brands"]),
  },
};

export default Brands;
